<template>
    <div v-if="state" class="EventCategoryGrid">
        <a v-for="(item, key) in orderedItems" :key="key" :href="state.createURL(item.value)" class="EventCategoryGrid__cell" @click.prevent="handleRefine(item.value)">
            <BaseImage
                :placeholder="item.placeholder"
                :srcset="item.image"
                :ratio="item.ratio"
                class="mb-small"
            />
            <h3 class="text--blue">{{ item.label }}</h3>
        </a>
    </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectMenu } from 'instantsearch.js/es/connectors';

export default {
    name: 'EventCategoryGrid',

    mixins: [
        createWidgetMixin({ connector: connectMenu })
    ],

    props: {
        attribute: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            images: window.eventCategories,
            sortingMap: {
                'Lifestyle': 1,
                'Festivals & Celebrations': 2,
                'Eat & Drink': 3,
                'Markets': 4,
                'Arts, Culture & Heritage': 5,
                'Sports & Adventure': 6
            }
        };
    },

    computed: {
        mergedItems() {
            if (!this.state) return [];

            return this.state.items.map((item) => {
                const matched = this.images ? this.images.find((obj) => obj.lookup === item.label) || {} : {};
                return {...item, ...matched};
            });
        },
        orderedItems() {
            return [...this.mergedItems].sort((a, b) => {
                return this.sortingMap[a.label] - this.sortingMap[b.label]
            })
        },
        widgetParams() {
            return {
                attribute: this.attribute,
                sortBy: ['name:asc']
            };
        },
    },

    methods: {
        async scrollTop() {
            await this.$nextTick();
            setTimeout(() => {
                const el = document.getElementById('searchTop');
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            });
        },
        async handleRefine(value) {
            await this.state.refine(value);
            await this.scrollTop();
        }
    }
}
</script>

<style lang="scss" scoped>
    .EventCategoryGrid {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        @include media-query(lap-and-up) {
            justify-content: flex-start;
        }
    }

    .EventCategoryGrid__cell {
        width: calc(50% - 1rem);
        margin-bottom: 2rem;
        flex-grow: 0;

        @include media-query(lap-and-up) {
            width: calc(25% - 1.5rem);
            margin-right: 2rem;

            &:nth-child(4n) {
                margin-right: 0;
            }
        }
    }

    h3 {
        text-transform: uppercase;
    }
</style>
